import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg, fromKSTInput } from "@/lib/api";

const inFiveDaysKST = () => new Date(Date.now() + (5 * 24 + 9) * 3600 * 1000).toISOString().slice(0, 16);

export const CollectSetDialog = ({ dropId, setNumber, onClose, onDone }) => {
  const [when, setWhen] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (setNumber) setWhen(inFiveDaysKST());
  }, [setNumber]);
  const save = async () => {
    if (!when) return toast.error("Pick a pay-by date");
    setBusy(true);
    try {
      await api.post(`/drops/${dropId}/collect-set`, { set_number: setNumber, pay_by: fromKSTInput(when) });
      toast.success(`Set #${setNumber} is collecting initials`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!setNumber} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="collect-set-dialog" className="bg-zinc-950 border-zinc-800 text-white">
        <DialogHeader>
          <DialogTitle>Collect Set #{setNumber}</DialogTitle>
          <DialogDescription className="text-zinc-400">Locks this set (no new claims or move-ups) and its claims are owed right away. The rest of the drop stays open.</DialogDescription>
        </DialogHeader>
        <label className="text-sm text-zinc-300">
          Pay-by date (KST)
          <input type="datetime-local" data-testid="collect-pay-by-input" value={when} onChange={(e) => setWhen(e.target.value)}
            className="mt-1.5 w-full rounded-lg border border-zinc-700 bg-zinc-900 px-3 py-2 text-sm text-white [color-scheme:dark]" />
        </label>
        <DialogFooter>
          <Button variant="ghost" data-testid="collect-cancel-btn" onClick={onClose}>Cancel</Button>
          <Button data-testid="collect-confirm-btn" disabled={busy} onClick={save}>{busy ? "Collecting…" : "Collect"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
